// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

/* export const environment = {
  production: false
};
 */

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDiAs1Nnfv2v9y1fTW3E_WY4MH14KdKlyc",
    authDomain: "project1-c2cfd.firebaseapp.com",
    databaseURL: "https://project1-c2cfd-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "project1-c2cfd",
    storageBucket: "project1-c2cfd.appspot.com",
    messagingSenderId: "265245544245",
    appId: "1:265245544245:web:80da95a6148114c2bfc67c",
    measurementId: "G-6K67122SP5"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
